export default __webpack_public_path__ + "static/media/img-home5.c9c0b26a.png";